<template>
    <v-row v-if="!$store.getters.progress" class="ma-0">
        <v-col cols="12" class="pa-0">
			<v-card class="pa-0 round-card background-2">
				<v-card-title class="pa-3">
					<div>
						<p class="pl-2 pl-xl-3">Costi di spedizione</p>
					</div>						
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-container class="pa-0" fluid>
					<v-row class="ma-0">	
						<v-col cols="4" sm="6" md="3">
							<v-text-field
								label="Peso"
								type="number"
								suffix="Kg"
								min="0"
								v-model.number="model['weight']"
								:error-messages="errors.collect('Peso')"
								v-validate="'required|decimal:2'"
								data-vv-name="Peso"
								outlined
								dense
							></v-text-field>
						</v-col>
						<v-col class="px-4" cols="4">
							<v-autocomplete
								label="Provincia"
								v-model="model['province_id']"
								:items="getProvinces"
								clearable
								no-data-text='Nessun risultato'
								:error-messages="errors.collect('Provincia')"
								v-validate="'required'"
								data-vv-name="Provincia"
								outlined
								dense
							></v-autocomplete>
						</v-col>														
						<v-col class="px-4" cols="6">
							<v-switch 
								label="Extra Comune"
								inset
								color="primary"
								v-model="model['extra_country']"
							></v-switch>
						</v-col>
					</v-row>

					<div class="px-4">
						<v-btn dark color="primary" @click="getData()">Calcola</v-btn>
					</div>

					<v-data-table
						:items="items"
						:headers="headers"
						:loading="loading"
						hide-default-footer
						disable-pagination
						class="background-2 round-card">
						<template v-slot:item="{ item }">
							<tr class="cursor-pointer">
								<td>
									{{ item['name'] }}
								</td>
								<td>
									{{ item['fixed_cost'] | currency}}
								</td>					    	
								<td>
									{{ calcTotal(item) | currency }}
								</td>
							</tr>
						</template>
					</v-data-table>

				</v-container>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>

	export default {
		name: 'shippingcosts',
		data() {
			return {
				fieldsset: {},
				headers: [],
				model: {'extra_country': false},
				loaded: false,
				items: [],
				loading: false,
			}
		},

		created() {

			this.axios.get('shippingcosts-info').then(response => {
				// get body data
				this.fieldsset = response.data.info.fields
				this.headers = response.data.info.headers

				_.forEach(this.fieldsset, (value, key) => {
					if(value.default) {
						Vue.set(this.model, value.key, value.default)
					}
				})

				this.$store.commit('endProgress')

			}, response => {
				// error callback
			});
		},

		methods: {

			getData() {
				this.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}
					this.loading = "warning"
					this.axios.post('shippingcosts-filters', this.model).then(response => {
						this.items = response.data.data

						this.filtered = true
						this.loading = false

					}, response => {
					// error callback
					})
				}).catch(() => {

				})
			},

			calcTotal(item) {
				let total = parseFloat(item.fixed_cost) + parseFloat(item.cost)
				if(this.model.extra_country == true) {
					total += parseFloat(item.extra_country_cost)
				}
				return total
			}
		},

		computed: {
			getProvinces() {
				if(this.fieldsset.provinces && this.fieldsset.provinces.options) {
					return this.fieldsset.provinces.options 
				} else return []
			}
		},
	}
</script>